module.exports = __webpack_public_path__ + "static/media/reg_s8_img.74b8503e.jpg";